import React from 'react';
import { Alert, Button, Empty, Tag, Typography } from 'antd';
import { MatchesTable } from './MatchesTable';
import { fmtNum, type MatchesState } from './model';

const { Text } = Typography;

interface Props {
  state: MatchesState;
  onOpenMatch: (id: string) => void;
  onOpenPlayer: (userId: string) => void;
  onLoadMore: () => void;
}

/** Everything under the controls: the players q resolved to, the table, Load more. */
export const MatchesReport: React.FC<Props> = ({
  state,
  onOpenMatch,
  onOpenPlayer,
  onLoadMore,
}) => {
  const { rows, matchedPlayers, nextCursor, searched, loading, loadingMore, error } = state;
  return (
    <>
      {error && <Alert type="error" showIcon message={error} style={{ marginBottom: 12 }} />}
      {matchedPlayers.length > 0 && (
        <div style={{ marginBottom: 8 }} data-matched-players="1">
          <Text type="secondary" style={{ marginRight: 8 }}>
            Matches of:
          </Text>
          {matchedPlayers.map((p) => (
            <Tag
              key={p.userId}
              color="blue"
              style={{ cursor: 'pointer' }}
              data-player={p.userId}
              onClick={() => onOpenPlayer(p.userId)}
            >
              {p.name ?? p.userId.slice(0, 8)}
            </Tag>
          ))}
        </div>
      )}
      {searched && !loading && rows.length === 0 && !error ? (
        <Empty description="No matches for this search" style={{ margin: '48px 0' }} />
      ) : (
        <MatchesTable
          rows={rows}
          loading={loading}
          onOpenMatch={onOpenMatch}
          onOpenPlayer={onOpenPlayer}
        />
      )}
      {rows.length > 0 && (
        <div style={{ textAlign: 'center', marginTop: 12 }}>
          <Text type="secondary" style={{ display: 'block', fontSize: 12, marginBottom: 8 }}>
            {fmtNum(rows.length, 0)} matches shown{nextCursor == null ? ' (all)' : ''}
          </Text>
          {nextCursor != null && (
            <Button onClick={onLoadMore} loading={loadingMore}>
              Load more
            </Button>
          )}
        </div>
      )}
    </>
  );
};
